import type { ClampParams } from './types';

const clamp = ({ max, min, value }: ClampParams): number => {
    if (value < min) {
        return min;
    }

    if (value > max) {
        return max;
    }

    return value;
};

export default clamp;
